import { ADJUSTMENT_NEGATIVE, ADJUSTMENT_POSITIVE } from '@/utils/const';
import React from 'react';
import {
  StyledGridRow,
  StyledGridRowContent,
  StyledRowWrapper,
  StyledSpan,
  StyledUserId,
} from './style';

type RecapProduct = {
  brandDescription?: string;
  upcCode?: string;
  quantity?: number;
  qtySold?: number;
  qtyFound?: number;
  qtyTotalFound?: number;
  adj?: number;
  movementType?: string;
  flowType: string;
};

const ProductTableRow: React.FC<RecapProduct> = ({
  brandDescription,
  upcCode,
  quantity,
  qtySold,
  qtyFound,
  qtyTotalFound,
  adj,
  movementType,
  flowType,
}) => {
  const isMndlOrPdm = ['MNDL', 'PDM'].includes(flowType);
  const movement = movementType ?? '';
  const sign = !isMndlOrPdm
    ? ADJUSTMENT_NEGATIVE.includes(movement)
      ? '-'
      : ADJUSTMENT_POSITIVE.includes(movement)
      ? '+'
      : ''
    : '';
  const adjDisplay = !isMndlOrPdm
    ? `${sign}${Math.abs(adj as number) || 0}`
    : '-';

  return (
    <StyledRowWrapper bgcolor="#E9EDF4">
      <StyledGridRow>
        <StyledGridRowContent>
          <StyledUserId>
            <StyledSpan font="medium">{brandDescription}</StyledSpan>
          </StyledUserId>
          <StyledSpan font="medium">{upcCode}</StyledSpan>
          <StyledSpan className={'text-number'} font="medium">
            {quantity}
          </StyledSpan>
          <StyledSpan className={'text-number'} font="medium">
            {!isMndlOrPdm ? qtySold || 0 : '-'}
          </StyledSpan>
          <StyledSpan className={'text-number'} font="medium">
            {!isMndlOrPdm ? qtyFound || 0 : '-'}
          </StyledSpan>
          <StyledSpan className={'text-number'} font="medium">
            {!isMndlOrPdm ? qtyTotalFound || 0 : '-'}
          </StyledSpan>
          <StyledSpan
            className={'text-number'}
            font="medium"
            $movementType={movementType}
          >
            {adjDisplay}
          </StyledSpan>
        </StyledGridRowContent>
      </StyledGridRow>
    </StyledRowWrapper>
  );
};

export default ProductTableRow;
